import featureFlags from '~/util/featureFlags';

export enum MOTIFS {
  spring = 'spring',
  summer = 'summer',
  fall_autumn = 'fall_autumn',
  winter = 'winter',
  floral = 'floral',
  greenery = 'greenery',
  rustic = 'rustic',
  destination = 'destination',
  beach = 'beach',
  modern = 'modern',
  elegant_formal = 'elegant_formal',
  simple_minimalist = 'simple_minimalist',
  typography = 'typography',
  classic_traditional = 'classic_traditional',
  monogram = 'monogram',
  boho = 'boho',
  mountains = 'mountains',
  vintage_retro = 'vintage_retro',
  maximalist = 'maximalist',
  nautical = 'nautical',
  barn_country = 'barn_country',
  whimsical = 'whimsical',
  border = 'border',
  geometric = 'geometric',
  cultural = 'cultural',
  watercolor = 'watercolor',
  disney = 'disney',
}

export enum COLORS {
  brown = 'brown',
  peach = 'peach',
  beige = 'beige',
  multi = 'multi',
  yellow = 'yellow',
  rose = 'rose',
  dusty_rose = 'dusty_rose',
  grey = 'grey',
  orange = 'orange',
  black = 'black',
  blue = 'blue',
  burgundy = 'burgundy',
  coral = 'coral',
  dusty_blue = 'dusty_blue',
  emerald_green = 'emerald_green',
  gold = 'gold',
  green = 'green',
  lavender = 'lavender',
  navy = 'navy',
  pink = 'pink',
  plum = 'plum',
  purple = 'purple',
  red = 'red',
  rose_gold = 'rose_gold',
  royal_blue = 'royal_blue',
  silver = 'silver',
  teal = 'teal',
  white = 'white',
}

export enum SHAPES {
  square = 'square',
  rounded = 'rounded',
  scalloped = 'scalloped',
  diamond = 'diamond',
  ticket = 'ticket',
  arch = 'arch',
  halfArch = 'half-arch',
  oval = 'oval',
}

export enum OCCASIONS {
  hanukkah = 'hanukkah',
  kwanzaa = 'kwanzaa',
  christmas = 'christmas',
  new_year = 'new_year',
  seasons_greetings = 'seasons_greetings',
  disney_holiday = 'disney_holiday',
}

export enum FEATURES {
  has_foil = 'has_foil',
  has_magnet = 'has_magnet',
  has_custom_photo = 'has_custom_photo',
  has_no_custom_photo = 'has_no_custom_photo',
  is_letterpress = 'is_letterpress',
  is_vow_renewal = 'is_vow_renewal',
}

export enum ORIENTATIONS {
  is_portrait = 'is_portrait',
  is_landscape = 'is_landscape',
}

export type AllFilters = MOTIFS | COLORS | SHAPES | OCCASIONS | FEATURES | ORIENTATIONS;

type FilterTemplateVariables = {
  [key in AllFilters]: {
    /** The filter's name (in title case). Used in multiple meta fields. */
    label: string;
    /** String appended to the base URL to generate a canonical URL */
    urlSuffix: string;
  };
};

export const FILTER_TEMPLATE_VARIABLES: FilterTemplateVariables = {
  [MOTIFS.spring]: {
    label: 'Spring',
    urlSuffix: '/spring',
  },
  [MOTIFS.summer]: {
    label: 'Summer',
    urlSuffix: '/summer',
  },
  [MOTIFS.fall_autumn]: {
    label: 'Fall & Autumn',
    urlSuffix: '/fall_autumn',
  },
  [MOTIFS.winter]: {
    label: 'Winter',
    urlSuffix: '/winter',
  },
  [MOTIFS.floral]: {
    label: 'Floral',
    urlSuffix: '/floral',
  },
  [MOTIFS.greenery]: {
    label: 'Greenery',
    urlSuffix: '/greenery',
  },
  [MOTIFS.rustic]: {
    label: 'Rustic',
    urlSuffix: '/rustic',
  },
  [MOTIFS.destination]: {
    label: 'Destination Themed',
    urlSuffix: '/destination',
  },
  [MOTIFS.beach]: {
    label: 'Beach Themed',
    urlSuffix: '/beach',
  },
  [MOTIFS.modern]: {
    label: 'Modern & Contemporary',
    urlSuffix: '/modern',
  },
  [MOTIFS.elegant_formal]: {
    label: 'Elegant & Formal',
    urlSuffix: '/elegant_formal',
  },
  [MOTIFS.simple_minimalist]: {
    label: 'Simple & Minimalist',
    urlSuffix: '/simple_minimalist',
  },
  [MOTIFS.typography]: {
    label: 'Typography',
    urlSuffix: '/typography',
  },
  [MOTIFS.classic_traditional]: {
    label: 'Classic & Traditional',
    urlSuffix: '/classic_traditional',
  },
  [MOTIFS.monogram]: {
    label: 'Monogram',
    urlSuffix: '/monogram',
  },
  [MOTIFS.boho]: {
    label: 'Boho',
    urlSuffix: '/boho',
  },
  [MOTIFS.mountains]: {
    label: 'Mountain',
    urlSuffix: '/mountains',
  },
  [MOTIFS.vintage_retro]: {
    label: 'Vintage & Retro',
    urlSuffix: '/vintage_retro',
  },
  [MOTIFS.maximalist]: {
    label: 'Maximalist',
    urlSuffix: '/maximalist',
  },
  [MOTIFS.nautical]: {
    label: 'Nautical',
    urlSuffix: '/nautical',
  },
  [MOTIFS.barn_country]: {
    label: 'Barn & Country',
    urlSuffix: '/barn_country',
  },
  [MOTIFS.whimsical]: {
    label: 'Whimsical',
    urlSuffix: '/whimsical',
  },
  [MOTIFS.border]: {
    label: 'Bordered',
    urlSuffix: '/border',
  },
  [MOTIFS.geometric]: {
    label: 'Geometric',
    urlSuffix: '/geometric',
  },
  [MOTIFS.cultural]: {
    label: 'Cultural',
    urlSuffix: '/cultural',
  },
  [MOTIFS.watercolor]: {
    label: 'Watercolor',
    urlSuffix: '/watercolor',
  },
  [MOTIFS.disney]: {
    label: 'Disney',
    urlSuffix: '/disney',
  },
  [COLORS.brown]: {
    label: 'Brown',
    urlSuffix: '/brown',
  },
  [COLORS.peach]: {
    label: 'Peach',
    urlSuffix: '/peach',
  },
  [COLORS.beige]: {
    label: 'Beige',
    urlSuffix: '/beige',
  },
  [COLORS.multi]: {
    label: 'Multi-Colored',
    urlSuffix: '/multi',
  },
  [COLORS.yellow]: {
    label: 'Yellow',
    urlSuffix: '/yellow',
  },
  [COLORS.rose]: {
    label: 'Rose',
    urlSuffix: '/rose',
  },
  [COLORS.dusty_rose]: {
    label: 'Dusty Rose',
    urlSuffix: '/dusty_rose',
  },
  [COLORS.grey]: {
    label: 'Grey',
    urlSuffix: '/grey',
  },
  [COLORS.orange]: {
    label: 'Orange',
    urlSuffix: '/orange',
  },
  [COLORS.black]: {
    label: 'Black',
    urlSuffix: '/black',
  },
  [COLORS.blue]: {
    label: 'Blue',
    urlSuffix: '/blue',
  },
  [COLORS.burgundy]: {
    label: 'Burgundy',
    urlSuffix: '/burgundy',
  },
  [COLORS.coral]: {
    label: 'Coral',
    urlSuffix: '/coral',
  },
  [COLORS.dusty_blue]: {
    label: 'Dusty Blue',
    urlSuffix: '/dusty_blue',
  },
  [COLORS.emerald_green]: {
    label: 'Emerald Green',
    urlSuffix: '/emerald_green',
  },
  [COLORS.gold]: {
    label: 'Gold',
    urlSuffix: '/gold',
  },
  [COLORS.green]: {
    label: 'Green',
    urlSuffix: '/green',
  },
  [COLORS.lavender]: {
    label: 'Lavender',
    urlSuffix: '/lavender',
  },
  [COLORS.navy]: {
    label: 'Navy Blue',
    urlSuffix: '/navy',
  },
  [COLORS.pink]: {
    label: 'Pink',
    urlSuffix: '/pink',
  },
  [COLORS.plum]: {
    label: 'Plum',
    urlSuffix: '/plum',
  },
  [COLORS.purple]: {
    label: 'Purple',
    urlSuffix: '/purple',
  },
  [COLORS.red]: {
    label: 'Red',
    urlSuffix: '/red',
  },
  [COLORS.rose_gold]: {
    label: 'Rose Gold',
    urlSuffix: '/rose_gold',
  },
  [COLORS.royal_blue]: {
    label: 'Royal Blue',
    urlSuffix: '/royal_blue',
  },
  [COLORS.silver]: {
    label: 'Silver',
    urlSuffix: '/silver',
  },
  [COLORS.teal]: {
    label: 'Teal',
    urlSuffix: '/teal',
  },
  [COLORS.white]: {
    label: 'White',
    urlSuffix: '/white',
  },
  [SHAPES.square]: {
    label: featureFlags.get('squarePaperOrientation') ? 'Standard' : 'Square',
    urlSuffix: '/square',
  },
  [SHAPES.rounded]: {
    label: 'Rounded',
    urlSuffix: '/rounded',
  },
  [SHAPES.scalloped]: {
    label: 'Scalloped',
    urlSuffix: '/scalloped',
  },
  [SHAPES.diamond]: {
    label: 'Diamond',
    urlSuffix: '/diamond',
  },
  [SHAPES.ticket]: {
    label: 'Ticket',
    urlSuffix: '/ticket',
  },
  [SHAPES.arch]: {
    label: 'Arch',
    urlSuffix: '/arch',
  },
  [SHAPES.halfArch]: {
    label: 'Half arch',
    urlSuffix: '/half-arch',
  },
  [SHAPES.oval]: {
    label: 'Oval',
    urlSuffix: '/oval',
  },
  [OCCASIONS.hanukkah]: {
    label: 'Hanukkah',
    urlSuffix: '/hanukkah',
  },
  [OCCASIONS.kwanzaa]: {
    label: 'Kwanzaa',
    urlSuffix: '/kwanzaa',
  },
  [OCCASIONS.christmas]: {
    label: 'Christmas',
    urlSuffix: '/christmas',
  },
  [OCCASIONS.seasons_greetings]: {
    label: "Season's Greetings",
    urlSuffix: '/seasons_greetings',
  },
  [OCCASIONS.new_year]: {
    label: 'New Year',
    urlSuffix: '/new_year',
  },
  [OCCASIONS.disney_holiday]: {
    label: 'Disney Holiday',
    urlSuffix: '/disney_holiday',
  },
  [FEATURES.has_foil]: {
    label: 'Foil',
    urlSuffix: '?features=foil',
  },
  [FEATURES.has_magnet]: {
    label: 'Magnet',
    urlSuffix: '?features=magnet',
  },
  [FEATURES.has_custom_photo]: {
    label: 'Photo',
    urlSuffix: '?features=customphoto',
  },
  [FEATURES.has_no_custom_photo]: {
    label: 'Non-Photo',
    urlSuffix: '?features=nocustomphoto',
  },
  [FEATURES.is_letterpress]: {
    label: 'Letterpress',
    urlSuffix: '?is_letterpress=is_letterpress',
  },
  [FEATURES.is_vow_renewal]: {
    label: 'Reception Only',
    urlSuffix: '?receptionOnly=elopementandvowrenewal',
  },
  [ORIENTATIONS.is_portrait]: {
    label: 'Portrait',
    urlSuffix: '?orientations=portrait',
  },
  [ORIENTATIONS.is_landscape]: {
    label: 'Landscape',
    urlSuffix: '?orientations=landscape',
  },
};
